import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

// const LineChart = ({data}) => {
//   const series = [{
//     name: 'In',
//     data: new Array(data.length).fill(0)
//   }, {
//     name: 'Out',
//     data: new Array(data.length).fill(0)
//   }];

//   const categoriesData = [];

//   for (let i = 0; i < data.length; i++) {
//         categoriesData.push(data[i].hour);
//         series[0].data[i] = data[i].inCount;
//         series[1].data[i] = data[i].outCount;
//   }

//   console.log(categoriesData,series[0].data, series[1].data,"dat");

//   const options = {
//     chart: {
//       height: 350,
//       type: 'area'
//     },
//     dataLabels: {
//       enabled: false
//     },
//     stroke: {
//       curve: 'smooth'
//     },
//     xaxis: {
//       categories: categoriesData,
//     },
//     // tooltip: {
//     //   x: {
//     //     format: 'dd/MM/yy HH:mm'
//     //   }
//     // },
//     colors: ["#800080", "#4169E1"],
//     title: {
//         text: 'Hotels',
//         align: 'center',
//         margin: 10,
//         offsetX: 0,
//         offsetY: 0,
//         floating: false,
//         style: {
//           fontSize:  '14px',
//           fontWeight:  'bold',
//           fontFamily:  undefined,
//           color:  '#263238'
//         },
//     }

//   };

//   return (
//     <div>
//       <div id="chart">
//         <ReactApexChart options={options} series={series} type="area" height={350} />
//       </div>
//       <div id="html-dist"></div>
//     </div>
//   );
// }

const fun = (prop, to) => {
    const categoriesData = [];
    const InData = [];
    const OutData = [];

    for (let i = 0; i < prop.data.length; i++) {
        categoriesData.push(prop.data[i].hour);
        InData.push(prop.data[i].inCount);
        OutData.push(prop.data[i].outCount);
    }

    if (to === "cat") {
        return categoriesData;
    } else if (to === "in") {
        return InData;
    } else if (to === "out") {
        return OutData;
    }
    // const filed = data.filter(it=>it.hour);
};

class LineChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [
                {
                    name: "In",
                    data: fun(props, "in"),
                },
                {
                    name: "Out",
                    data: fun(props, "out"),
                },
            ],
            options: {
                chart: {
                    height: 350,
                    type: "area",
                    toolbar: {
                        show: true,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: false,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            pan: false,
                            reset:
                                false |
                                '<img src="/static/icons/reset.png" width="20">',
                            customIcons: [],
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: "smooth",
                },
                xaxis: {
                    // type: 'datetime',
                    categories: fun(props, "cat"),
                },
                colors: ["#800080", "#4169E1"],

                //   tooltip: {
                //     x: {
                //       format: 'dd/MM/yy HH:mm'
                //     },
                //   },
                title: {
                    text: "Hotels",
                    align: "center",
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: "14px",
                        fontWeight: "bold",
                        fontFamily: undefined,
                        color: "#263238",
                    },
                },
            },
        };
    }

    render() {
        return (
            <div>
                <div id="chart">
                    <ReactApexChart
                        options={this.state.options}
                        series={this.state.series}
                        type="area"
                        height={350}
                    />
                </div>
                <div id="html-dist"></div>
            </div>
        );
    }
}

export default LineChart;
